<template>
  <div class="radio-card__working">
    <hr />
    <div class="radio-card-working-info">
      <div>
        <b-form-group class="p-0 m-0 col-">
          <label for="radio-working" class="m-0 p-0 label__radio-working">Company name</label>
          <b-form-radio
            v-model="selectedWorking"
            class="radio-item-working"
            name="radio-kmutt"
            value="KMUTT"
          >
            <span class="radio-checked"> KMUTT </span>
          </b-form-radio>
          <b-form-radio
            v-model="selectedWorking"
            class="radio-item-working"
            name="radio-other"
            value="Other"
          >
            <span class="radio-checked"> Other </span>
            <b-form-input
              v-if="selectedWorking === 'Other'"
              v-model="form.otherCompany"
              class="input__other-company"
              type="text"
              :state="errorState('otherCompany')"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="isShowRequiedFeedbackText('otherCompany')"
              ref="input__error-required"
              class="text_feedback"
            >
              Company name is required
            </b-form-invalid-feedback>
          </b-form-radio>
          <b-form-radio
            v-model="selectedWorking"
            class="radio-item-working"
            name="radio-not-say"
            :value="null"
          >
            <span class="radio-checked">Prefer not to say</span>
          </b-form-radio>
        </b-form-group>
      </div>
      <div class="card__industry-of-work">
        <label for="input__area-of-employment" class="m-0 p-0 label__area-of-employment"
          >Industry of work</label
        >
        <b-form-select
          id="input__area-of-employment"
          ref="input__area-of-employment"
          v-model="form.area_of_employment"
          class="input__area-of-employment"
          :options="employmentAreas"
          value-field="value"
          text-field="name"
          :state="errorState('area_of_employment')"
        >
          <template #first>
            <b-form-select-option :value="null" disabled> Choose... </b-form-select-option>
          </template>
        </b-form-select>
        <b-form-invalid-feedback
          v-if="isShowRequiedFeedbackText('area_of_employment')"
          ref="input__error-required"
        >
          Industry of work is required
        </b-form-invalid-feedback>
      </div>
    </div>
  </div>
</template>

<script>
import * as PROFILE_OPTIONS from '@/assets/user-profile-template.json';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      selectedWorking: 'KMUTT',
      form: {
        company: '',
        area_of_employment: null,
        otherCompany: ''
      }
    };
  },
  validations() {
    return {
      form: {
        area_of_employment: {
          required
        },
        otherCompany: {
          required: requiredIf(function () {
            return this.selectedWorking === 'Other';
          })
        }
      }
    };
  },
  computed: {
    employmentAreas() {
      return PROFILE_OPTIONS.aboutYouFields.fields.employmentArea.options;
    }
  },
  watch: {
    selectedWorking: {
      handler(newValue) {
        this.form.area_of_employment = newValue === 'KMUTT' ? 'education' : null;
      },
      immediate: true
    }
  },
  methods: {
    updateWorkingChecked() {
      if (this.selectedWorking === 'Other') {
        this.$set(this.form, 'company', this.form.otherCompany);
      } else {
        this.$set(this.form, 'otherCompany', '');
        this.$set(this.form, 'company', this.selectedWorking);
      }

      this.$v.$touch();

      this.$emit('submit:working-professional', this.form);
    },

    errorState(key) {
      return this.$v.form[key].$dirty
        ? this.$v.form[key].$anyError
          ? !this.$v.form[key].$anyError
          : null
        : null;
    },

    isShowRequiedFeedbackText(dataKey) {
      return this.isErrorFeedbackText(dataKey, 'required');
    },

    //return true if NOT meet requirment
    isErrorFeedbackText(dataKey, errorKey) {
      return this.$v.form[dataKey].$dirty ? !this.$v.form[dataKey][`${errorKey}`] : false;
    }
  }
};
</script>

<style lang="scss">
.radio-card__working {
  margin-left: 10px;

  .radio-card-working-info {
    width: fit-content;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  .radio-item-working {
    margin-top: 1rem;
  }

  .radio-checked {
    margin-left: 3px;
  }

  .card__industry-of-work {
    .input__area-of-employment {
      margin-top: 1rem;
      cursor: pointer;
    }
  }

  @media screen and (max-width: 576px) {
    .radio-card-working-info {
      grid-template-columns: 1fr;
      gap: 0;
    }
    .radio-item-working {
      margin: 1rem 0;
    }
  }

  @media screen and (min-width: 1200px) and(max-width: 1440px) {
    .radio-card-working-info {
      grid-template-columns: 1fr;
      gap: 0;
    }
    .radio-item-working {
      margin: 1rem 0;
    }
  }

  .was-validated .custom-select:invalid,
  .custom-select.is-invalid {
    background: url('../../../assets/on-boarding/icon-form-onboarding/invalid-feedback.svg') #fff
      no-repeat right 1.3rem center/ 8px 10px;
  }
}
</style>
